import { kpiRangeForDays } from './kpiRollup';
import { useProjectContext } from '@/project/ProjectContext';
import { Button } from '@/components/ui/Button';
import styles from '../../pages/DashboardPage.module.css';

type Props = {
  rangeDays: 7 | 30 | 90;
};

export function GoogleCsvExport({ rangeDays }: Props) {
  const { selectedProjectId } = useProjectContext();
  const { from, to } = kpiRangeForDays(rangeDays);

  function exportCsv() {
    const q = new URLSearchParams({ from, to });
    if (selectedProjectId) q.set('project_id', selectedProjectId);
    window.open(`/api/dashboard/google/export?${q.toString()}`, '_blank', 'noopener,noreferrer');
  }

  return (
    <Button variant="secondary" type="button" onClick={exportCsv} className={styles.exportBtn}>
      CSV export
    </Button>
  );
}
